/* import __COLOCATED_TEMPLATE__ from './performance-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  title?: string;
}

const PerformanceEmptyState = templateOnlyComponent<Args>();
export default PerformanceEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Custom::PerformanceEmptyState': typeof PerformanceEmptyState;
    'reporting/custom/performance-empty-state': typeof PerformanceEmptyState;
  }
}
